// src/config/Auth0Config.ts
import { CacheLocation } from "@auth0/auth0-spa-js";

export const auth0Config = {
  domain: "dev-s3vnvksip2ahk1kx.us.auth0.com",
  clientId: "nByoQh5EuZ3YRHIyduaL7fbBXyyGrkuy",
  redirect_uri: window.location.origin,
  cacheLocation: "localstorage" as CacheLocation, //temporary
  useRefreshTokens: true,
  audience: "https://users.api.avetasystem.support",
  scope: "openid profile email offline_access access_as_user role:admin",
};
